import request from "../utils/request";

//获取商品配置
export function getTranslateConfig(data, customerCode) {
    return request({
        url: `/fieldmapping/${customerCode}`,
        method: 'get',
        data,
    });
}

export function editTranslateConfig(data, customerCode) {
    return request({
        url: `/fieldmapping/${customerCode}`,
        method: 'post',
        data,
    });
}